export function build() {
  function parse(actionsString: string) {
    const actions: any[] = [];
    const actionsRegex = /(\w+)\[([^\]]+)\]/g;

    let match;
    while ((match = actionsRegex.exec(actionsString)) !== null) {
      const action = match[1];
      const params = match[2].split(',').map((param) => param.trim());
      actions.push({
        object: 'action',
        name: action,
        params,
      });
    }

    return {
      object: 'actions',
      data: actions,
    };
  }

  return {
    parse,
  };
}
